import { MetaDataItem } from '../types'

export const METADATA_DATA_ITEMS_PTK: MetaDataItem[] = [
  {
    number: 1,
    variable: 'Nomor Unik Pendidik dan Tenaga Kependidikan',
    objectClass: 'PTK',
    objectSubClass: 'Identitas',
    alias: 'NUPTK',
    definition:
      'Kode referensi berbentuk nomor unik bagi pendidik dan tenaga kependidikan sebagai identitas dalam menjalankan tugas pada satuan pendidikan yang berfungsi sebagai nomor identitas pendidik dan tenaga kependidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Format 16 (enam belas) digit angka',
      'valid berdasarkan mekanisme verifikasi dan validasi sesuai peraturan perundang-undangan',
    ],
    question: 'NUPTK dari pendidik dan tenaga kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 2,
    variable: 'Nama Lengkap',
    objectClass: 'PTK',
    objectSubClass: 'Identitas',
    alias: 'Nama Lengkap',
    definition:
      'Penyebutan untuk memanggil seseorang sebagai identitas diri sesuai dokumen kependudukan nasional',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Valid sesuai dengan data kependudukan nasional',
    ],
    question: 'Nama Lengkap Pendidik Dan Tenaga Kependidikan',
    publicText: 'Rahasia',
    isPublic: false,
  },
  {
    number: 3,
    variable: 'Jenis Pendidik dan Tenaga Kependidikan',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'Jenis Pendidik dan Tenaga Kependidikan',
    definition:
      'Tenaga kependidikan adalah anggota masyarakat yang mengabdikan diri dan diangkat untuk menunjang penyelenggaraan pendidikan.Pendidik adalah tenaga kependidikan yang berkualifikasi sebagai guru, dosen, konselor, pamong belajar, widyaiswara, tutor, instruktur, fasilitator, dan sebutan lain yang sesuai dengan kekhususannya, serta berpartisipasi dalam menyelenggarakan pendidikan.',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: [
      'Guru Kelas',
      'Guru Mata Pelajaran',
      'Guru Bimbingan Konseling',
      'Guru Pendamping Khusus / Guru Inklusi',
      'Tenaga Administrasi Sekolah',
      'Guru Teknologi, Informasi, dan Kom',
      'Guru Pengganti',
      'Guru Pembimbing Khusus',
      'Instruktur Kejuruan',
      'Kepala Sekolah',
      'Pengawas BK',
      'Pengawas SD',
      'Laboran',
      'Tenaga Perpustakaan',
      'Tukang Kebun',
      'Penjaga Sekolah',
      'Petugas Keamanan',
      'Pesuruh/Office Boy',
      'Terapis',
      'Academic Advisor',
      'Academic Specialist',
      'Curriculum Development Advisor',
      'Kindergarten Teacher',
      'Management Advisor',
      'Play Group Teacher',
      'Principal',
      'Teaching Assistant',
      'Vice Principal',
      'Instruktur',
      'Penguji',
      'Master Penguji',
      'Tutor',
      'Pamong Belajar',
      'Pengawas PaudDikmas',
      'Penilik',
      'Tenaga Kependidikan',
      'Dosen',
      'Lainnya',
    ],
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format sesuai dengan klasifikasi isian',
      'Valid sesuai dengan SK Satuan Administrasi Pangkalan',
    ],
    question: 'Jenis pendidik dan tenaga kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 4,
    variable: 'Jenis Kelamin',
    objectClass: 'PTK',
    objectSubClass: 'Identitas',
    alias: 'Jenis Kelamin',
    definition: 'Jenis kelamin sesuai dokumen kependudukan nasional',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Undang-Undang tentang Administrasi Kependudukan',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Valid sesuai dengan data kependudukan nasional',
    ],
    question: 'Jenis Kelamin Pendidik Dan Tenaga Kependidikan',
    publicText: 'Rahasia',
    isPublic: false,
  },
  {
    number: 5,
    variable: 'NIK',
    objectClass: 'PTK',
    objectSubClass: 'Identitas',
    alias: 'NIK',
    definition:
      'Nomor identitas kependudukan sesuai dokumen kependudukan nasional.',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Format 16 (enam belas) digit angka',
      'Valid sesuai dengan data kependudukan nasional',
    ],
    question: 'NIK Pendidik Dan Tenaga Kependidikan',
    publicText: 'Rahasia',
    isPublic: false,
  },
  {
    number: 6,
    variable: 'Tempat Lahir',
    objectClass: 'PTK',
    objectSubClass: 'Identitas',
    alias: 'Tempat Lahir',
    definition: 'Nama kota tempat lahir sesuai dokumen kependudukan nasional',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Undang-Undang tentang Administrasi Kependudukan',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Valid sesuai dengan data kependudukan nasional',
    ],
    question: 'Tempat Lahir Pendidik Dan Tenaga Kependidikan',
    publicText: 'Rahasia',
    isPublic: false,
  },
  {
    number: 7,
    variable: 'Tanggal Lahir',
    objectClass: 'PTK',
    objectSubClass: 'Identitas',
    alias: 'Tanggal Lahir',
    definition:
      'Tanggal, bulan dan tahun lahir sesuai dokumen kependudukan nasional',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'Date',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Format berupa tanggal',
      'Valid sesuai dengan data kependudukan nasional',
    ],
    question: 'Tanggal Lahir Pendidik Dan Tenaga Kependidikan',
    publicText: 'Rahasia',
    isPublic: false,
  },
  {
    number: 8,
    variable: 'Nama Lengkap Ibu Kandung',
    objectClass: 'PTK',
    objectSubClass: 'Identitas',
    alias: 'Nama Lengkap Ibu Kandung',
    definition:
      'Penyebutan untuk memanggil ibu kandung seseorang sebagai identitas diri sesuai dokumen kependudukan nasional',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Valid sesuai dengan data kependudukan nasional',
    ],
    question: 'Nama Lengkap Ibu Kandung Pendidik Dan Tenaga Kependidikan',
    publicText: 'Rahasia',
    isPublic: false,
  },
  {
    number: 9,
    variable: 'Status Kepegawaian',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'Status Kepegawaian',
    definition:
      'Status ikatan kerja sesuai dengan pemenuhan syarat kepegawaian yang telah ditentukan berdasarkan peraturan perundang-undangan yang berlaku',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: ['ASN', 'Bukan ASN'],
    validationRules: [
      'Isian tidak boleh kosong, berupa pilihan',
      'Format sesuai dengan klasifikasi isian',
      'Valid sesuai dengan SK Satuan Administrasi Pangkalan',
    ],
    question: 'Status Kepegawaian Pendidik Dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 10,
    variable: 'Lembaga Pengangkat',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'Lembaga Pengangkat',
    definition: 'Lembaga yang mengangkat',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian tidak boleh kosong',
      'Valid sesuai dengan SK Satuan Administrasi Pangkalan',
    ],
    question: 'Lembaga Pengangkat Pendidik dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 11,
    variable: 'Surat Keputusan Pengangkatan',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'SK Pengangkatan',
    definition:
      'Surat Keputusan Pengangkatan sebagai Pendidik dan Tenaga Kependidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: ['- Isian tidak boleh kosong'],
    question:
      'Surat Keputusan Pengangkatan sebagai Pendidik dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 12,
    variable: 'Terhitung Mulai Tanggal Pengangkatan',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'TMT Pengangkatan',
    definition:
      'Tanggal resmi ditetapkan menjadi Pendidik dan Tenaga Kependidikan yang tercantum pada Surat keputusan pengangkatan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'Date',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian tidak boleh kosong',
      'Valid sesuai dengan SK Satuan Administrasi Pangkalan',
    ],
    question: 'Tanggal dimulainya Pendidik dan Tenaga Kependidikan bertugas',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 13,
    variable: 'Sumber Gaji',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'Sumber Gaji',
    definition: 'Sumber gaji Pendidik dan Tenaga Kependidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: [
      'APBN',
      'APBD Provinsi',
      'APBD Kabupaten/Kota',
      'Yayasan',
      'Sekolah',
      'Lembaga Donor',
      'Lainnya',
    ],
    validationRules: ['Isian tidak boleh kosong'],
    question: 'Sumber gaji Pendidik dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 14,
    variable: 'Kepemilikan Lisensi Kepala Sekolah',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'Kepemilikan Lisensi Kepala Sekolah',
    definition:
      'Kepemilikan lisensi menjadi kepala sekolah bagi Pendidik dan Tenaga Kependidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String atau Boolean',
    inputClassification: 'Tidak ada',
    validationRules: ['Isian tidak boleh kosong'],
    question: 'Memiliki lisensi kepala sekolah',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 15,
    variable: 'Nomor Surat Tugas',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'Nomor Surat Tugas',
    definition: 'Nomor yang tercantum pada surat keputusan penugasan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: ['Isian tidak boleh kosong'],
    question: 'Nomor Surat Tugas Pendidik dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 16,
    variable: 'Tanggal Surat Tugas',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'Tanggal Surat Tugas',
    definition: 'Tanggal diterbitkannya surat keputusan penugasan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'Date',
    inputClassification: 'Tidak ada',
    validationRules: ['Isian tidak boleh kosong'],
    question: 'Tanggal Surat Tugas Pendidik dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 17,
    variable: 'Terhitung Mulai Tanggal Tugas',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'TMT Tugas',
    definition:
      'Tanggal resmi bertugas menjadi Pendidik dan Tenaga Kependidikan yang tercantum pada Surat keputusan penugasan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'Date',
    inputClassification: 'Tidak ada',
    validationRules: ['Isian tidak boleh kosong'],
    question: 'TMT Tugas Pendidik dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 18,
    variable: 'Surat Keputusan Penugasan',
    objectClass: 'PTK',
    objectSubClass: 'Kepegawaian',
    alias: 'SK Penugasan',
    definition:
      'Surat keputusan penugasan seseorang menjadi Pendidik dan Tenaga Kependidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: ['Isian tidak boleh kosong'],
    question: 'SK Penugasan Pendidik dan Tenaga Kependidikan',
    publicText: 'Terbatas',
    isPublic: false,
  },
  {
    number: 19,
    variable: 'Nomor Pokok Satuan Pendidikan Nasional',
    objectClass: 'PTK',
    objectSubClass: 'Satuan Pendidikan',
    alias: 'NPSN',
    definition:
      'Kode referensi berbentuk nomor unik bagi satuan pendidikan yang berfungsi sebagai nomor identitas satuan pendidikan',
    selectionReference:
      'Keputusan Menteri Pendidikan, Kebudayaan, Riset, dan Teknologi Nomor 303/M/2022',
    timeReference: 'Tahun Ajaran',
    dataType: 'String',
    inputClassification: 'Tidak ada',
    validationRules: [
      'Isian Tidak Boleh Kosong',
      'Format 8 (delapan) digit yang terdiri atas kombinasi huruf dan/atau angka',
      'Valid berdasarkan mekanisme verifikasi dan validasi sesuai peraturan perundang-undangan',
    ],
    question: 'NPSN tempat Pendidik Dan Tenaga Kependidikan bertugas',
    publicText: 'Terbatas',
    isPublic: false,
  },
]
